import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 換 route 時自動 scroll 回頂部
    window.scrollTo({
      top: 0,
      behavior: "instant", // optional: 平滑滾動
    });
  }, [pathname]);

  return null; // 只做副作用，不 render UI
};

export default ScrollToTop;
